import { ComputedProductStatus, ProductSortField, ProductStockType } from "@/graphql/codegen/graphql"

export type ProductsSortableAccessorKey = "companyName" | "publicId" | "companyProductDescription" | "vendorDescription"

export const accessorKeyToProductsSortField = new Map<ProductsSortableAccessorKey, ProductSortField>([
  ["companyName", ProductSortField.CompanyName],
  ["publicId", ProductSortField.PublicId],
  ["companyProductDescription", ProductSortField.ProductSupplierDescription],
  ["vendorDescription", ProductSortField.ProductVendorDescription],
])

export const productsSortFieldToAccessoryKey = new Map<ProductSortField, ProductsSortableAccessorKey>([
  [ProductSortField.CompanyName, "companyName"],
  [ProductSortField.PublicId, "publicId"],
  [ProductSortField.ProductSupplierDescription, "companyProductDescription"],
  [ProductSortField.ProductVendorDescription, "vendorDescription"],
])

export const productStockTypeLabelMap = new Map<ProductStockType, string>([
  [ProductStockType.MadeToOrder, "MTO"],
  [ProductStockType.StockItem, "Stock Item"],
  [ProductStockType.NonStockItem, "Non Stock Item"],
])

export const productStatusLabelMap = new Map<ComputedProductStatus, string>([
  [ComputedProductStatus.Active, "Active"],
  [ComputedProductStatus.Inactive, "Inactive"],
  [ComputedProductStatus.Discontinued, "Discontinued"],
  [ComputedProductStatus.PendingApproval, "Pending"],
])
